import { render, staticRenderFns } from "./new_user.vue?vue&type=template&id=832ac118&"
import script from "./new_user.vue?vue&type=script&lang=js&"
export * from "./new_user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports